import styled from 'styled-components';

import { Color, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { hexToRgba } from '../../utils';
import { Image } from '../image/image.component';
import { ValidationBar } from '../validationBar/validationBar.component';

import { SuggestionsListProps } from './autosuggest.types';

export const Container: StyledComponent<'div'> = styled.div`
  position: relative;
`;

export const SuggestionsList: StyledComponent<'div', SuggestionsListProps> = styled.div<SuggestionsListProps>`
  position: absolute;
  top: 100%;
  left: 0;
  right: -2px;
  border: 1px solid ${Color.Gray300};
  background-color: ${Color.Gray100};
  transition: 0.3s;
  overflow: hidden;
  max-height: ${({ $isVisible }: SuggestionsListProps): string => $isVisible ? '262px' : '0'};
  opacity: ${({ $isVisible }: SuggestionsListProps): string => $isVisible ? '1' : '0'};
  z-index: ${ZIndex.AutosuggestSuggestionsList};
  box-shadow: 0px 0px 4.375px ${hexToRgba(Color.Black, 0.15)};
`;

export const SuggestionElement: StyledComponent<'button'> = styled.button`
  display: flex;
  align-items: center;
  padding: 0 8px;
  height: 52px;
  transition: 0.3s;
  width: 100%;

  &:hover {
    background-color: ${Color.Gray200};
  }

  & + & {
    border-top: 1px solid ${Color.Gray300};
  }
`;

export const ImageContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 36px;
  flex-shrink: 0;
`;

export const ImageElement: StyledComponent<typeof Image> = styled(Image)`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

export const SuggestionLabel: StyledComponent<'div'> = styled.div`
  font-size: 16px;
  line-height: 22px;
  color: ${Color.Gray500};

  ${ImageContainer} + & {
    margin-left: 10px;
  }
`;

export const StyledValidationBar: StyledComponent<typeof ValidationBar> = styled(ValidationBar)`
  margin-bottom: 16px;
`;
